/**
 * @module Header
 */

import '../../scripts/common';

import '../../scripts/autosize';
import '../../scripts/picture';

import Component from '../base/Component';
import Search from '../Search';
import BrandsPreview from '../BrandsPreview';
import CategoryPreview from '../CategoryPreview';
import Popup from '../base/Popup';
import MobileMenu from '../MobileMenu';
import './styles.css';

import { media } from '../../scripts/helpers';

import '../../images/sprite/logo.svg';
import '../../images/sprite/cart.svg';
import '../../images/sprite/user.svg';
import '../../images/sprite/search.svg';
import '../../images/sprite/micro.svg';
import '../../images/sprite/dermo_cosmetics.svg';
import '../../images/sprite/logo_pf_full.svg';
import '../../images/responsive/logo_rus.png';
import '../../images/responsive/pic_1.jpg';
import '../../images/responsive/pic_2.png';
import '../../images/responsive/pic_3.png';
import '../../images/responsive/pic_4.png';
import '../../images/responsive/pic_5.png';
import '../../images/responsive/pic_6.png';
import '../../images/responsive/pic_7.png';

/**
 * Название компонента.
 */
export default class Header extends Component {
    static className = 'header-main';
}

$(() => {
    Search.create();
    initBrandsPreview();
    CategoryPreview.create();
    initPopup();
    MobileMenu.create();
});

/**
 * Инициализация брендов
 */

function initBrandsPreview() {
    $('.brands-preview__item').each((i, item) => {
        const brandDefault = new BrandsPreview($(item));
        brandDefault.init({});
    });
}

/**
 * Мобильное меню
 */
function initPopup() {
    const popupMobileMenuObj = new Popup($('.popup--mobile-menu'));
    popupMobileMenuObj.init({
        animationOpen: 'fadeIn',
        animationClose: false,
        animationTime: 400,
    });
}

$(document).on('click', '.menu-btn', e => {
    if ($(e.currentTarget).hasClass('is-open')) {
        $(e.currentTarget).removeClass('is-open');
        $(e.currentTarget).attr('data-popup', 'open');
        $('header').insertBefore('.popup--mobile-menu');
    } else {
        $(e.currentTarget).addClass('is-open');
        $(e.currentTarget).attr('data-popup', 'close');

        $('header').prependTo('.popup--mobile-menu');
        $('.header-main').get(0).inert = false;
    }
});

/**
 * Прилипание хедера при скролле
 */
$(window).on('load', () => {
    const $stickyHeader = $('.js-sticky-header');
    const $fullHeader = $stickyHeader.closest('.js-header-main');

    let offsetHeight = $('.js-sticky-header').outerHeight();
    let minScroll = $fullHeader.outerHeight(); // Минимальная высота, которую надо проскроллить
    let isSticky; // Флаг для оптимизации перфоманса
    let lastScroll; // Последняя позиция после остановки скролла

    /**
     * Добавление/удаление класса "is-sticky"
     */
    $(document).on('scroll', () => {
        if (media('tablet').matches || $('.menu-btn').hasClass('is-open')) return;

        const currentScroll = window.pageYOffset;

        if (currentScroll > minScroll && !isSticky) {
            $fullHeader.css('paddingTop', `${offsetHeight}px`);
            $stickyHeader.addClass('is-sticky');
            isSticky = true;
            lastScroll = currentScroll;

            // Добавляем класс "is-smooth" после добавления "is-sticky" (чтобы избежать появления раньше времени)
            setTimeout(() => {
                $stickyHeader.addClass('is-smooth');
            }, 100);
        } else if (currentScroll <= minScroll) {
            // Очистка всех параметров
            clearAll();
        }

        // Плавное появление/исчезновение
        setAppearance(currentScroll);
    });

    /**
     * Настройка плавного появления/исчезновения блока, если класс "is-sticky" добавлен
     *
     * @param {number} currentScroll - числовое значение скролла
     */
    function setAppearance(currentScroll) {
        if (!isSticky || currentScroll === lastScroll) return;

        // Устанавливаем минимальное значение, при котором блок необходимо показывать
        const minScrollToShow = 500;
        // Небольшой дополнительный запас, чтобы не было резкого появления/исчезновения
        const minScrollToShowMargin = 500;

        if (currentScroll < lastScroll && currentScroll > minScrollToShow + minScrollToShowMargin) {
            $stickyHeader.addClass('is-visible');
        } else if (currentScroll > lastScroll || currentScroll <= minScrollToShow) {
            $stickyHeader.removeClass('is-visible');
        }

        lastScroll = currentScroll;
    }

    /**
     * Очистка всех параметров
     */
    function clearAll() {
        $fullHeader.css('paddingTop', '');
        $stickyHeader.removeClass('is-sticky');
        $stickyHeader.removeClass('is-visible');
        $stickyHeader.removeClass('is-smooth');
        isSticky = false;
    }

    /**
     * Обновление всех параметров при ресайзе
     */
    let timerId;
    $(window).on('resize', () => {
        clearTimeout(timerId);

        timerId = setTimeout(() => {
            if (media('tablet').matches) return;

            offsetHeight = $('.js-sticky-header').outerHeight();
            minScroll = $fullHeader.outerHeight(); // Минимальная высота, которую надо проскроллить

            if (isSticky) {
                $fullHeader.css('paddingTop', `${offsetHeight}px`);
            }
        }, 200);
    });

    /**
     * Очистка параметров сжатии экрана до смартфонов
     */
    media('tablet').addListener(mql => {
        if (mql.matches) clearAll();
    });
});
